<div
  class="acceptance"
  [class.acceptance--error]="showError"
  [class.acceptance--disabled]="control.disabled"
>
  <label class="acceptance__label" [for]="uniqueId">

    <!-- Checkbox nativa nascosta + custom visuale -->
    <input
      type="checkbox"
      class="acceptance__input"
      [id]="uniqueId"
      [formControl]="control"
    />
    <span
      class="acceptance__custom"
      [class.acceptance__custom--checked]="control.value === true"
      [class.acceptance__custom--error]="showError"
      aria-hidden="true"
    ></span>

    <!-- Testo etichetta: segmenti semplici o con link -->
    <span class="acceptance__text">
      @for (seg of segments; track $index) {
        @if (seg.url) {
          <a
            class="acceptance__link"
            [href]="seg.url"
            [target]="seg.external ? '_blank' : '_self'"
            [rel]="seg.external ? 'noopener noreferrer' : null"
            (click)="seg.external ? $event.stopPropagation() : openContractModal($event, seg.url)"
          >{{ seg.text }}</a>
        } @else {
          <span>{{ seg.text }}</span>
        }
      }
      @if (isRequired) {
        <span class="acceptance__asterisk" aria-hidden="true"> *</span>
      }
    </span>

  </label>

  <!-- Errore inline -->
  @if (showError) {
    <span class="acceptance__error" role="alert" aria-live="polite">
      Accettazione obbligatoria per procedere
    </span>
  }
</div>
